import _toConsumableArray from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "tab-teach"
};
var _hoisted_2 = {
  class: "left"
};
var _hoisted_3 = {
  class: "right"
};
import { watch, ref, reactive, computed, onMounted } from 'vue';
/** 组件 */
import FormItem from './formItem';
import { exportTeacherData, getGroupTeacher, getStudentTeacher } from '@/api/index-jiao';
import { dateFormat, getRandomString } from '../utils';
export default {
  __name: 'teachTab',
  props: {
    classId: {
      type: String,
      default: ''
    },
    cycle: {
      type: String,
      default: ''
    },
    outClassTypeName: {
      type: String,
      default: ''
    },
    outClassName: {
      type: String,
      default: ''
    }
  },
  emits: ['changeTab'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var emits = __emit;
    var groupOptions = ref([]);
    var studentOptions = ref([]);
    var states = reactive({
      groupId: '',
      studentId: ''
    });
    var handleChange = function handleChange() {
      emits('changeTab', states);
    };
    var ownerGroupName = computed(function () {
      var _groupOptions$value$f;
      return ((_groupOptions$value$f = groupOptions.value.find(function (item) {
        return item.value === states.groupId;
      })) === null || _groupOptions$value$f === void 0 ? void 0 : _groupOptions$value$f.name) || '';
    });
    var ownerStudentName = computed(function () {
      var _studentOptions$value;
      return ((_studentOptions$value = studentOptions.value.find(function (item) {
        return item.value === states.studentId;
      })) === null || _studentOptions$value === void 0 ? void 0 : _studentOptions$value.name) || '';
    });
    var getGroupTeacherData = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              data = {
                classId: props.classId
              };
              _context.n = 1;
              return getGroupTeacher(data).then(function (res) {
                groupOptions.value = res.data.data;
                if (groupOptions.value.length > 0) {
                  states.groupId = groupOptions.value[0].value;
                } else {
                  states.groupId = '';
                }
              });
            case 1:
              getStudentDatasByGroup();
              emits('changeTab', states);
            case 2:
              return _context.a(2);
          }
        }, _callee);
      }));
      return function getGroupTeacherData() {
        return _ref2.apply(this, arguments);
      };
    }();
    var getStudentDatasByGroup = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var studentData;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(states.groupId && props.classId)) {
                _context2.n = 2;
                break;
              }
              studentData = {
                groupId: states.groupId,
                classId: props.classId
              };
              _context2.n = 1;
              return getStudentTeacher(studentData).then(function (res) {
                studentOptions.value = res.data.data;
                var allData = {
                  name: '全部',
                  value: ''
                };
                studentOptions.value.unshift(allData);
                states.studentId = '';
              });
            case 1:
              _context2.n = 3;
              break;
            case 2:
              studentOptions.value = [];
              states.studentId = '';
            case 3:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      return function getStudentDatasByGroup() {
        return _ref3.apply(this, arguments);
      };
    }();

    // 修改小组，查询学生
    var handleChangeGroup = function handleChangeGroup() {
      getStudentDatasByGroup();
      handleChange();
    };

    // eslint-disable-next-line complexity
    var exportExcle = function exportExcle(data) {
      var blob = new Blob([data], {
        type: 'application/vnd.ms-excel'
      });
      var objectUrl = URL.createObjectURL(blob);
      var a = document.createElement('a');
      document.body.appendChild(a);
      a.style = 'display: none';
      a.href = objectUrl;
      var formatType = 'yyyy/MM/dd';
      var time = dateFormat(new Date(), formatType);
      var randomNum = getRandomString(2);
      var names = '';
      names = "".concat(props.outClassTypeName).concat(props.outClassTypeName ? '-' : '').concat(props.outClassName).concat(props.outClassName ? '-' : '').concat(props.cycle).concat(props.cycle ? '-' : '');
      names += "".concat(ownerGroupName.value).concat(ownerGroupName.value ? '-' : '').concat(ownerStudentName.value).concat(ownerStudentName.value ? '-' : '');
      a.download = "".concat(names, "\u8BFE\u5802\u4E92\u52A8\u6570\u636E-").concat(time, "-").concat(randomNum, ".xlsx");
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(objectUrl);
    };
    var handleExport = function handleExport() {
      exportTeacherData({
        schoolId: props.schoolId,
        cycle: props.cycle,
        classRoom: props.classId,
        groupId: states.groupId,
        studentId: states.studentId
      }).then(function (res) {
        exportExcle(res.data);
      });
    };
    watch(function () {
      return props.classId;
    }, function (newVal) {
      // 获取小组和学生数据
      getGroupTeacherData();
    });
    onMounted(function () {
      if (props.classId) {
        getGroupTeacherData();
      }
    });
    return function (_ctx, _cache) {
      var _component_svg_icon = _resolveComponent("svg-icon");
      var _component_t_select = _resolveComponent("t-select");
      var _component_t_button = _resolveComponent("t-button");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_svg_icon, {
        size: "28",
        name: "teacher-detail"
      }), _createElementVNode("span", null, [_renderSlot(_ctx.$slots, "title", {}, function () {
        return [_cache[2] || (_cache[2] = _createTextVNode("教师授课详情", -1))];
      })])]), _createElementVNode("div", _hoisted_3, [_createVNode(_unref(FormItem), null, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[3] || (_cache[3] = [_createTextVNode("小组", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.groupId,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
              return states.groupId = $event;
            }),
            options: groupOptions.value,
            keys: {
              label: 'name',
              value: 'value'
            },
            onChange: handleChangeGroup
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      }), _createVNode(_unref(FormItem), null, {
        formLabel: _withCtx(function () {
          return _toConsumableArray(_cache[4] || (_cache[4] = [_createTextVNode("学生", -1)]));
        }),
        formInput: _withCtx(function () {
          return [_createVNode(_component_t_select, {
            modelValue: states.studentId,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
              return states.studentId = $event;
            }),
            options: studentOptions.value,
            keys: {
              label: 'name',
              value: 'value'
            },
            onChange: handleChange
          }, null, 8, ["modelValue", "options"])];
        }),
        _: 1
      }), _createVNode(_component_t_button, {
        onClick: handleExport
      }, {
        default: _withCtx(function () {
          return _toConsumableArray(_cache[5] || (_cache[5] = [_createTextVNode("导出全部", -1)]));
        }),
        _: 1
      })])]);
    };
  }
};